import React from 'react'

export default function FullPageSpinner() {
  return <div>loading ...</div>
}
